export default {
    buttons: {
        login: 'Войти',
    },
    links: {
        forgot_password: 'Забыли пароль?',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        password: {
            label: 'Пароль',
            placeholder: 'Минимум 6 символов',
        },
    },
}
